import React from 'react';

export function TableHeaders({ columns, fks, fkOptions, sortConfig, handleSort, addGroup, groupByConfig = [] }) {
    // Filter out grouped columns
    const visibleColumns = columns.filter(col => !groupByConfig.includes(col.ColumnName));

    return (
        <thead className="text-xs uppercase bg-slate-700 text-slate-400 sticky top-0 shadow z-10">
            <tr>
                <th className="px-4 py-3 w-32 bg-slate-700">Actions</th>
                {visibleColumns.map(col => {
                    const isFk = fks.some(fk => fk.ColumnName === col.ColumnName);
                    let headerText = col.ColumnName;
                    let hoverTitle = col.ColumnName;

                    if (isFk && fkOptions[col.ColumnName]) {
                        headerText = fkOptions[col.ColumnName].displayCol;
                        hoverTitle = fkOptions[col.ColumnName].fullPath;
                    }

                    const sortState = sortConfig.find(s => s.key === col.ColumnName);

                    return (
                        <th key={col.ColumnName} title={hoverTitle} className="px-4 py-3 bg-slate-700 whitespace-nowrap group">
                            <div className="flex items-center gap-1">
                                <span 
                                    className="cursor-pointer hover:text-white transition-colors flex-1"
                                    onClick={() => handleSort(col.ColumnName)}
                                >
                                    {headerText}
                                    {col.IsPrimaryKey && <span className="ml-1 text-yellow-500" title="Primary Key">🔑</span>}
                                    {col.IsIdentity && <span className="ml-1 text-slate-500" title="Auto-Increment Identity">⚡</span>}
                                    {sortState && (
                                        <span className="ml-1 text-blue-400">
                                            {sortState.direction === 'asc' ? '▲' : '▼'}
                                        </span>
                                    )}
                                </span>
                                
                                <button 
                                    className="opacity-0 group-hover:opacity-100 text-slate-500 hover:text-blue-400 transition-opacity"
                                    title="Group by this column"
                                    onClick={() => addGroup(col.ColumnName)}
                                >
                                    <span className="material-symbols-outlined text-[16px]">view_list</span>
                                </button>
                            </div>
                        </th>
                    );
                })}
            </tr>
        </thead>
    );
}
